module.exports = __webpack_public_path__ + "img/block-dueler.c61f505e.png";